import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { BaseApiService } from '@core/api/base-api.service';
import { RoleDto } from '../models/rbac.model';

@Injectable({ providedIn: 'root' })
export class RoleService {
  private readonly api = inject(BaseApiService);
  private readonly base = 'v1/admin/rbac/roles';

  getTenantRoles(tenantUuid: string): Observable<readonly RoleDto[]> {
    const params = new HttpParams().set('tenantUuids', tenantUuid).set('size', '100');
    return this.api.get<any>(this.base, { params }).pipe(
      map((res) => {
        const data = res?.data ?? res;
        const arr = Array.isArray(data) ? data : Array.isArray(data?.content) ? data.content : [];
        return (arr as any[])
          .filter((r) => !!r?.roleName)
          .map((r) => ({
            accountUuid: r.accountUuid ?? '',
            roleName: r.roleName,
            tenantUuid: r.tenantUuid ?? tenantUuid,
          }));
      }),
    );
  }

  // tenantUuid is required: role names (ADMIN, MANAGER...) repeat in every tenant.
  assignRole(roleName: string, accountEmail: string, tenantUuid: string): Observable<void> {
    return this.api
      .post<void>(`${this.base}/${encodeURIComponent(roleName)}/assign`, {
        accountEmail,
        tenantUuid,
      })
      .pipe(map(() => void 0));
  }

  unassignRole(roleName: string, accountEmail: string, tenantUuid: string): Observable<void> {
    return this.api
      .delete(
        `${this.base}/${encodeURIComponent(roleName)}/assign/${encodeURIComponent(accountEmail)}` +
          `?tenantUuid=${encodeURIComponent(tenantUuid)}`,
      )
      .pipe(map(() => void 0));
  }
}
